import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["appearsIn"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { CollapsedButtonsGroup } from '../../buttons/CollapsedButtonsGroup';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../../hooks/searchParamHooks';
import UsageTracker from '../../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ContentSourceFilter = _ref => {
  let {
      appearsIn
    } = _ref,
    cardWrapperProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [contentSourceParams, setContentSource] = useSearchParam(FILTER_TYPES.CONTENT_SOURCE);
  const [contentSource = 'ALL_CONTENT'] = contentSourceParams;
  const handleFilterChange = filter => {
    UsageTracker.trackStandalone('Filter Interaction', {
      action: 'filter-selected',
      value: filter !== null && filter !== void 0 ? filter : 'ALL_CONTENT',
      key: 'content-source-filter',
      appearsIn
    });
    setContentSource(filter);
  };
  return /*#__PURE__*/_jsx(CardWrapper, Object.assign({
    marginBlockEnd: "600",
    padding: "400"
  }, cardWrapperProps, {
    children: /*#__PURE__*/_jsx(TFlex, {
      alignItems: "center",
      gap: 16,
      children: /*#__PURE__*/_jsxs(CollapsedButtonsGroup, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Button, {
          active: contentSource === 'ALL_CONTENT',
          onClick: () => handleFilterChange(null),
          use: "tertiary-extra-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.topFilters.contentSource.ALL_CONTENT"
          })
        }), /*#__PURE__*/_jsx(Button, {
          active: contentSource === 'CUSTOM_CONTENT',
          onClick: () => handleFilterChange('CUSTOM_CONTENT'),
          use: "tertiary-extra-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.topFilters.contentSource.CUSTOM_CONTENT"
          })
        }), /*#__PURE__*/_jsx(Button, {
          active: contentSource === 'ACADEMY',
          onClick: () => handleFilterChange('ACADEMY'),
          use: "tertiary-extra-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.topFilters.contentSource.ACADEMY"
          })
        })]
      })
    })
  }));
};